import './admin.css';
import Authenticated from '../lib/authenticated';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen, faHashtag, faXmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';

function fetchStaff(toast, setStaff) {
    fetch('/v1/api/staff', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-Content-Range': 'items=0-1000',
            'x-Pattern': document.getElementById("search")?.value || '',
        },
    }).then(response => {
        if (response.ok) {
            response.json().then(data => {
                setStaff(data);
            });
        } else {
            toast.error('Failed to load staff data.');
        }
    });
}

function createStaff(toast) {
    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const access = document.getElementById("access").value;

    if (!name || !email) {
        toast.error('Name and email are required.');
        return;
    }

    fetch('/v1/api/staff', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            fullname: name,
            email: email,
            accesslevel: access,
        }),
    }).then(response => {
        if (response.ok) {
            toast.success('Staff created successfully.');
            fetchStaff(); // Refresh the staff list
        } else {
            toast.error('Failed to create staff. Please try again.');
        }
    });
}

function handleResetLockDown(toast, staffId) {
    fetch(`/v1/api/staff/${staffId}/lock-down`, {
        method: 'DELETE',
    }).then(response => {
        if (response.ok) {
            toast.success('Lock down reset successfully.');
        } else {
            toast.error('Failed to reset lock down.');
        }
    });
}

function handleClearTokens(toast, staffId) {
    fetch(`/v1/api/staff/${staffId}/secrets`, {
        method: 'DELETE',
    }).then(response => {
        if (response.ok) {
            toast.success('Tokens cleared successfully.');
        } else {
            toast.error('Failed to clear tokens.');
        }
    });
}

function handleDelete(toast, staffId) {
    fetch(`/v1/api/staff/${staffId}`, {
        method: 'DELETE',
    }).then(response => {
        if (response.ok) {
            toast.success('Staff deleted successfully.');
            fetchStaff(); // because staff is a state the component will re-render
        } else {
            toast.error('Failed to delete staff.');
        }
    });
}

export default function Admin() {
    const [staff, setStaff] = useState(null);
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (toast && setStaff) fetchStaff(toast, setStaff);
    }, [toast, setStaff, search]);

    return <Authenticated>
        <div className="admin">
            <main>
                <input id='search' type="text" className='search' placeholder='Search...' onChange={e => setSearch(e.target.value)} />
                <div className='create-staff'>
                    <input id="name" type="text" placeholder='Staff Name' />
                    <input id="email" type="email" placeholder='staff@example.com' />
                    <div>
                        <select id="access">
                            <option value="staff">staff</option>
                            <option value="admin">admin</option>
                        </select>
                        <button onClick={createStaff}><FontAwesomeIcon icon={faPlus} /></button>
                    </div>
                </div>
                <table>
                    <thead hidden>
                        <tr>
                            <th>Id</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Access</th>
                            <th>Reset Lock Down</th>
                            <th>Clear Tokens</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {staff ? staff.map((member) => (
                            <tr>
                                <td className='col-id'>{member.id}</td>
                                <td className='col-name'>{member.fullname}</td>
                                <td className='col-email'>{member.email}</td>
                                <td className='col-access'>{member.accesslevel}</td>
                                <td className='col-actions'>
                                    <button title='Reset Lock Down' onClick={() => {handleResetLockDown(member.id)}}><FontAwesomeIcon icon={faLockOpen} /></button>
                                    <button title='Clear Tokens' onClick={() => {handleClearTokens(member.id)}}><FontAwesomeIcon icon={faHashtag} /></button>
                                    <button title='Delete' onClick={() => {handleDelete(member.id)}}><FontAwesomeIcon icon={faXmark} /></button>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="4">Loading staff data...</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </main>
            <ToastContainer />
        </div>
    </Authenticated>;
}
